import { createSlice } from '@reduxjs/toolkit';
import { LoanConsentState } from '../types/state';

export const initialState: LoanConsentState = {
  docOrder: [],
};

export const loanConsentSlice: any = createSlice({
  name: 'loanConsent',
  initialState,
  reducers: {
    setDocOrder: (state, action) => {
      state.docOrder = action.payload;
    },
  },
});

export const { setDocOrder } = loanConsentSlice.actions;

export default loanConsentSlice.reducer;
